module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_woman-43f440a7b0f725c2fcab131da915de2a.png";